/**
 * step-transformer.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { AlgorithmStep } from "../../structure/";
import { TransformerEffects } from "./transformer-effects";
export { TransformerEffects } from "./transformer-effects";

/**
 * A {@link StepTransformer} is a general interface for elements of the
 * {@link AlgorithmStep} processing pipeline, allowing an arbitrary list of
 * transformations to partake in the step creation process.
 */
export abstract class StepTransformer
{
    // Once collected, transformers are sorted by their order, allowing a very
    // rough method of defining interdependencies / timings between them.
    public abstract readonly order : number;

    /**
     * The transformation itself, called upon the steps.
     */
    public abstract apply (step : AlgorithmStep) : TransformerEffects;

    /**
     * The transformation itself, called upon the steps.
     */
    public abstract create (step : AlgorithmStep) : TransformerEffects;

    /**
     * Whether this transformer can be used for a general step class.
     */
    public abstract matchesType (stepType : any) : boolean;

    /**
     * Whether this transformer can be used on a specific step instance
     */
    // public abstract matches (step : AlgorithmStep) : boolean;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/management/pipeline/step-transformer.ts